/* eslint-disable no-unused-vars */
import { useCallback, useEffect, useState } from 'react'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import moment from 'moment'

import { homePath, transformData } from '@/utils'
import { CarCarStatusChoices, useCarQuery } from '@/apollo/graphql'
import { ICar, TFormSubmit } from '@/types'
import { useAPI } from '@/hooks/index'

interface IUseData {
  id?: string
}

interface IUseDataRes {
  loading: boolean
  submitting: boolean
  data: Partial<ICar> | undefined
  onSubmit: TFormSubmit<ICar>
  onCancel: () => void
}

const defaultData: Partial<ICar> = {
  status: CarCarStatusChoices.WaitingForSale,
}

export const useData = ({ id }: IUseData): IUseDataRes => {
  const navigate: NavigateFunction = useNavigate()
  const { submitting, sendForm } = useAPI()
  const [data, setData] = useState<Partial<ICar>>(defaultData)

  const { loading, refetch } = useCarQuery({
    skip: !id,
    fetchPolicy: 'network-only',
    variables: {
      id: id || '',
    },
    onCompleted: res => {
      if (res.car) {
        // @ts-ignore
        setData({
          ...(res.car || {}),
          status: res.car.status || CarCarStatusChoices.WaitingForSale,
        })
      }
    },
  })

  useEffect(() => {
    if (!id) {
      setData(defaultData)
    }
  }, [id])

  const onSubmit: TFormSubmit<ICar> = useCallback(
    (path, isEdit, callback) => d => {
      if (d.insuranceExpDate) {
        d.insuranceExpDate = moment(d.insuranceExpDate).format('YYYY-MM-DD')
      }
      if (d.licenceExpDate) {
        d.licenceExpDate = moment(d.licenceExpDate).format('YYYY-MM-DD')
      }
      sendForm(
        {
          path,
          method: isEdit ? 'PUT' : 'POST',
          data: transformData(d),
          callback: e => {
            callback?.(e)
            refetch()
          },
        },
        { showNotify: true },
      )
    },
    [refetch, sendForm],
  )

  const onCancel = useCallback(() => {
    navigate(homePath)
  }, [navigate])

  return {
    loading,
    submitting,
    data,
    onSubmit,
    onCancel,
  }
}
